import { GET_CHALLENGE, GET_ROLES, GET_SKILL_TOPICS, GET_USERS, TOGGLE_CHALLENGE, GET_CHALLENGES_LIST, CREATE_CHALLENGE, GET_USER_SKILL_CHALLENGES, GET_USER_SKILL_TOPICS, GET_USER_SKILL_RESOURCES, GET_TESTS_LIST, GET_CHALLENGE_TEST, START_CHALLENGE_TEST, SUBMIT_CHALLENGE_TEST, CAPTURE_CHALLENGE_ANALYTICS, RESET_CHALLENGE } from '../../actionType/type';
let intialState = {
    isLoading: true,
    challengesList: [],
    challenge: {},
    roles: [],
    skillTopics: [],
    users: [],
    toggleChallenge: false,
    SkillLoading: true,
    topicLoading: true,
    resourceLoading: true,
    challengeAnalytics: {},
    challengeTest: {},
    startChallengeTest: {},
    submitChallengeTest: {},
}

export default function challengeReducer(state = intialState, action) {
    let stateCopy = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case RESET_CHALLENGE:
            stateCopy.userSkillChallenges = [];
            stateCopy.SkillLoading = true;
            stateCopy.numberOfChallenges = 0;
            return stateCopy;
        case GET_CHALLENGES_LIST:
            stateCopy.isLoading = false;
            stateCopy.challengesList = action.payload;
            return stateCopy;
        case GET_CHALLENGE:
            stateCopy.challenge = action.payload;
            return stateCopy;
        case GET_ROLES:
            stateCopy.roles = action.payload;
            return stateCopy;
        case GET_TESTS_LIST:
            stateCopy.testsList = action.payload;
            return stateCopy;
        case GET_SKILL_TOPICS:
            stateCopy.skillTopics = action.payload;
            return stateCopy;
        case GET_USERS:
            stateCopy.users = action.payload;
            return stateCopy;
        case CREATE_CHALLENGE:
            stateCopy.challengeId = action.payload._id;
            return stateCopy;
        case TOGGLE_CHALLENGE:
            stateCopy.challengesList.forEach((challenge) => {
                if (challenge._id == action.payload.challengeId) {
                  challenge.active = !action.payload.currentStatus;
                }
              });
              return stateCopy;
        case GET_USER_SKILL_CHALLENGES:
            stateCopy.SkillLoading = false;
            stateCopy.userSkillChallenges = action.payload;
            stateCopy.numberOfChallenges = action.payload.reduce((acc, skill) => acc + skill.challenges.length, 0);
            stateCopy.allChallenges = action.payload.flatMap(skill => skill.challenges);
            return stateCopy;
        case GET_USER_SKILL_TOPICS:
            stateCopy.topicLoading = false;
            stateCopy.userSkillTopics = action.payload;
            return stateCopy;
        case GET_USER_SKILL_RESOURCES:
            stateCopy.resourceLoading = false;
            stateCopy.userSkillResources = action.payload;
            return stateCopy;
        case CAPTURE_CHALLENGE_ANALYTICS:
            stateCopy.challengeAnalytics = action.payload;
            return stateCopy;
        case GET_CHALLENGE_TEST:
            stateCopy.challengeTest = action.payload;
            stateCopy.testDetails = {
                title: action.payload.test_title,
                test_id: action.payload.test_id,
                questions: action.payload.test_questions.length,
                time: action.payload.test_time
            };
            return stateCopy;
        case START_CHALLENGE_TEST:
            stateCopy.startChallengeTest = action.payload;
            return stateCopy;
        case SUBMIT_CHALLENGE_TEST:
            stateCopy.submitChallengeTest = action.payload;
            return stateCopy;
        default:
            return stateCopy;
    }
}
